var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-inherit hover:text-primary cursor-pointer",style:(_vm.color),on:{"click":_vm.url}},[_vm._v(_vm._s(_vm.params.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }